module.exports = __webpack_public_path__ + "media/images/flags/HU-4e5cbca18810d79c754ffe2ae1f9b60c.svg";